export default __webpack_public_path__ + "static/media/clientsIcon.c6d5e4d3.svg";